<template>
  <div
    v-if="attachments && attachments.length > 0"
    class="hrTimesheets-attachments-section manager-ts-attachments"
  >
    <div class="hrTimesheets-attachments-header">
      <i class="bi bi-paperclip"></i>
      <span>Attachments ({{ attachmentCount }})</span>
    </div>
    <div class="hrTimesheets-attachments-list">
      <div
        v-for="att in displayAttachments"
        :key="att.id"
        class="hrTimesheets-attachment-item manager-ts-card-attachment-item"
      >
        <HRTimesheetAttachmentRow
          :attachment="att"
          :clickable-stored-name="clickableStoredNames"
          @open-stored="(a) => $emit('open-stored', a)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HRTimesheetAttachmentRow from '@/modules/consultant/components/HRTimesheetAttachmentRow.vue';
import '../styles/ManagerTimesheetCardAttachments.css';

export default {
  name: 'ManagerTimesheetCardAttachments',
  components: { HRTimesheetAttachmentRow },
  emits: ['open-stored'],
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    listSource: {
      type: String,
      default: 'hr',
      validator: (v) => v === 'hr' || v === 'consultant'
    },
    /** Stored (non-URL) names open in viewer like manager Edit modal. */
    clickableStoredNames: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayAttachments() {
      return Array.isArray(this.attachments) ? this.attachments : [];
    },
    attachmentCount() {
      return this.displayAttachments.length;
    }
  }
};
</script>
